import React from "react";
import styled from "styled-components";

const ToggleSwitch = ({ value, bgColor, onClick, onChange, checked, width, height, bfwidth, bfheight, disabled }) => {
  return (
    <StyledToggleSwitch
      bgColor={bgColor}
      width={width}
      height={height}
      bfwidth={bfwidth}
      bfheight={bfheight}
      disabled={disabled}
    >
      <input
        className="toggle-checkbox"
        type="checkbox"
        value={value}
        onClick={onClick}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      ></input>
      <div className="toggle-switch"></div>
    </StyledToggleSwitch>
  );
};

export default ToggleSwitch;

const StyledToggleSwitch = styled.label.attrs((props) => ({
  bgColor: props.bgColor || "#56c080",
  width: props.width ? props.width : "58px",
  height: props.height ? props.height : "32px",
  bfwidth: props.bfwidth ? props.bfwidth : "24px",
  bfheight: props.bfheight ? props.bfheight : "24px",
  cursor: props.disabled ? "not-allowed" : "pointer",
  opacity: props.disabled ? "0.5" : "1",
  boxShadow: props.disabled ? "none" : "0 0 0 1px rgba(0, 0, 0, 0.25)",
  boxShadowHover: props.disabled ? "none" : "0 0 0 1px rgba(0, 0, 0, 0.5)",
}))`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  font-family: -apple-system, ".SFNSText-Regular", "Helvetica Neue", "Roboto", "Segoe UI", sans-serif;

  .toggle-switch {
    display: inline-block;
    cursor: ${(props) => props.cursor};
    background: #ccc;
    border-radius: 16px;
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
    opacity: ${(props) => props.opacity};
  }
  .toggle-switch:before,
  .toggle-switch:after {
    content: "";
  }
  .toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: ${(props) => props.boxShadow};
    width: ${(props) => props.bfwidth};
    height: ${(props) => props.bfheight};
    position: absolute;
    top: 4px;
    left: 4px;
    transition: left 0.25s;
  }
  &:hover .toggle-switch:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%);
    box-shadow: ${(props) => props.boxShadowHover};
  }
  .toggle-checkbox:checked + .toggle-switch {
    background: ${(props) => props.bgColor};
  }
  .toggle-checkbox:checked + .toggle-switch:before {
    left: 30px;
  }
  .toggle-checkbox {
    position: absolute;
    visibility: hidden;
  }
`;
